module.exports = __webpack_public_path__ + "img/homebut.aca77011.png";